/* Sprint C+D — Social Honesty Banner.
 *
 * Single source of truth for the language Furmais uses to explain
 * that we do not scrape social platforms, do not run platform APIs,
 * and do not claim content analysis without operator-provided
 * evidence. Reused by every Sprint C+D panel that touches social.
 */
import { ShieldAlert } from "lucide-react";

export default function SocialHonestyBanner({ compact = false }) {
    return (
        <div
            className={
                "rounded-lg border border-amber-500/30 bg-amber-500/5 " +
                "text-amber-200 " +
                (compact ? "p-2 text-[11px]" : "p-3 text-xs")
            }
            data-testid="social-honesty-banner"
        >
            <div className="flex items-start gap-2">
                <ShieldAlert className="w-4 h-4 mt-0.5 shrink-0 text-amber-300" />
                <div className="leading-relaxed">
                    <div className="font-semibold text-amber-100">
                        Honesty: Furmais does NOT scrape Instagram / Facebook / LinkedIn / X / TikTok / YouTube.
                    </div>
                    <div className="mt-1 text-amber-200/90">
                        All social facts here are URL-only, operator-pasted, or operator-uploaded.
                        Follower / engagement numbers shown reflect what you submitted —
                        Furmais will <span className="underline">not</span> verify them against the platform.
                        Every artifact below stays in “Pending” until you approve it.
                    </div>
                </div>
            </div>
        </div>
    );
}
